import React, { Component } from 'react';
import Editbox from '../../Part_Sample/Editbox';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty } from '../../Common/Common';

import UpArrow from '../../../Images/Daikin_Images/icon/UpArrow.png';
import DownArrow from '../../../Images/Daikin_Images/icon/DownArrow.png';

export default class Add_Edit_IAQ extends Component {
	constructor(props) {
		super(props);

		let room_name = '';
		let iaq_value = [];

		////////////////////////
		// this.props.param.iaq_settings (whole data store)
		// this.props.param.room_id		(current selected room name)
		// this.props.param.iaq_settings[this.props.param.room_id]	(device settings for current room)
		////////////////////////

		if (!isEmpty(this.props.param.room_id)) {
			room_name = this.props.param.room_id;

			if (this.props.param.iaq_settings.hasOwnProperty(this.props.param.room_id)) {
				iaq_value = this.props.param.iaq_settings[this.props.param.room_id];
			}
		}

		this.state = {
			room_name: room_name,
			iaq_value: iaq_value
		}
	}

	handlePrevious = () => {
		window.app.showLoading();
		this.props.receiver.readJSONFile({ name: 'iaq_monitoring_settings.json' });
	}

	handleChangeRoomName = (response) => {
		this.setState({ room_name: response })
	}

	handleAddIAQCommand = () => {
		window.app.showLoading();

		if (this.props.param.room_id == null) {
			if (this.state.room_name == '') {
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('no_name'), 3000);
				return;
			}

			for (var roomid in this.props.param.iaq_settings) {
				if (roomid == this.state.room_name) {
					window.app.hideLoading();
					window.app.showToast(this.props.receiver.getString('name_already_exists'), 3000);
					return;
				}
			}

			let tempResponse = JSON.parse(JSON.stringify(this.props.param.iaq_settings));
			tempResponse[this.state.room_name] = this.state.iaq_value;
			this.props.content_handler('Add_Edit_IAQ_Devices', { iaq_settings: tempResponse, room_id: this.state.room_name, selected_iaq_settings_index: null });
		} else {
			this.props.content_handler('Add_Edit_IAQ_Devices', { iaq_settings: this.props.param.iaq_settings, room_id: this.props.param.room_id, selected_iaq_settings_index: null });
		}
	}

	handleEditIAQDevice = (index) => {
		this.props.content_handler('Add_Edit_IAQ_Devices', { iaq_settings: this.props.param.iaq_settings, room_id: this.props.param.room_id, selected_iaq_settings_index: index });
	}

	handleRegister = () => {
		let tempName = this.state.room_name.split(/\s/).join('');  //check for names that are just spaces.

		if (tempName == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		if (isEmpty(this.state.iaq_value) || this.state.iaq_value.length == 0) {
			window.app.showToast(this.props.receiver.getString('no_management_points'), 3000);
			return;
		}

		window.app.showLoading();

		let tempResponse = JSON.parse(JSON.stringify(this.props.param.iaq_settings));

		if (this.props.param.room_id != this.state.room_name) {
			//check name duplication
			for (var roomid in this.props.param.iaq_settings) {
				if (roomid == this.state.room_name) {
					window.app.hideLoading();
					window.app.showToast(this.props.receiver.getString('name_already_exists'), 3000);
					return;
				}
			}

			//do name switch
			if (this.props.param.room_id == null) {												//Adding brand new room
				tempResponse[this.state.room_name] = this.state.iaq_value;
			} else {
				/*Object.defineProperty(tempResponse, this.state.room_name,						//define new room name
					Object.getOwnPropertyDescriptor(tempResponse, this.props.param.room_id)		//get all param of old room name
				);
				
				delete tempResponse[this.props.param.room_id];									//delete old room
				
				tempResponse[this.state.room_name] = this.state.iaq_value;*/

				delete Object.assign(tempResponse, { [this.state.room_name]: this.state.iaq_value })[this.props.param.room_id];
			}

		} else {
			tempResponse[this.props.param.room_id] = this.state.iaq_value;
		}

		this.props.receiver.saveJSONFile({ name: 'iaq_monitoring_settings.json', data: tempResponse });
	}

	handleDelete = () => {
		window.app.showLoading();

		let tempResponse = JSON.parse(JSON.stringify(this.props.param.iaq_settings));

		if (tempResponse.hasOwnProperty(this.props.param.room_id)) {
			delete tempResponse[this.props.param.room_id];
		}

		this.props.receiver.saveJSONFile({ name: 'iaq_monitoring_settings.json', data: tempResponse });
	}

	rcvSaveJSONFile(response) {
		if (response.result != 'NG') {
			this.props.receiver.readJSONFile({ name: 'iaq_monitoring_settings.json' });
		} else {
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvReadJSONFile(response) {
		if (response.result != 'NG') {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			this.props.content_handler('IAQ_Monitoring_Settings', { response: response.data });
		} else {
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('json_read_failed'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let sensor_type = ['co2', 'pm25', 'tvoc', 'co', 'temp', 'humi'];

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={isEmpty(this.props.param.room_id) ? this.props.receiver.getString('add_iaq_room') : this.props.receiver.getString('edit_iaq_room')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddIAQCommand}
					/>
					<div id='data' style={{ overflow: 'auto', height: this.props.height - 140, paddingbottom: 60 }}>
						<div style={{ textAlign: 'center', marginLeft: 20 }}>
							<Editbox id='room_name' style={{ width: this.props.width - 40 }} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeRoomName(event.target.value)} value={this.state.room_name} />
						</div>
						<div style={{ marginTop: 20, textAlign: 'left', marginLeft: 20 }}>
							<span className='title'> {this.props.receiver.getString('iaq_value')}</span>
						</div>

						<div style={{ marginLeft: 20 }}>
							{!isEmpty(this.state.iaq_value) && this.state.iaq_value.map((iaqDevice, index) => {
								let pid = iaqDevice.id;

								let point_type = iaqDevice.type;

								let point_name = window.app.state.point_list[pid].name;

								let point_unit = window.app.state.point_list[pid].unit;
								if(isEmpty(point_unit)) {
									if(window.app.state.point_list[pid].type == 'Ac') point_unit = 'DEG';
								}

								let point_yellow = iaqDevice.threshold_yellow;

								let point_red = iaqDevice.threshold_red;

								let yellow_label = <div style={{ display: 'inline-block', width: '15px', height: '15px', borderRadius: '50%', backgroundColor: '#FDE26C' }}> &nbsp; </div>;
								let red_label = <div style={{ display: 'inline-block', width: '15px', height: '15px', borderRadius: '50%', backgroundColor: '#FF6D6A' }}> &nbsp; </div>;

								if (point_type == 'temp' || point_type == 'humi') {
									//yellow_label = <span style={{ fontSize: 'large' }}> &#8595; </span>;
									//red_label = <span style={{ fontSize: 'large' }}> &#8593; </span>;
									yellow_label = <img src={DownArrow} style={{ width: '15px', paddingRight: '0px' }} />;
									red_label = <img src={UpArrow} style={{ width: '15px', paddingRight: '0px' }} />;
								}

								if (pid != null) {
									return (
										<div style={{ textAlign: 'left', marginTop: 10, width: this.props.width - 40, backgroundColor: '#f1f1f1', borderRadius: 10, minHeight: 70 }} onClick={() => this.handleEditIAQDevice(index)}>
											<div style={{ width: '95%', display: 'block', padding: '10px 10px 5px 10px' }}>
												<div style={{ display: 'inline-block', width: '65%', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
													{point_name}
												</div>

												<div style={{ marginLeft: 10, display: 'inline-block', width: '30%' }}>
													{/*this.props.receiver.getString(red_label) + ": " + point_red*/}
													{red_label} {point_red}
												</div>
											</div>

											<div style={{ width: '95%', display: 'block', padding: '5px 10px 10px 10px' }}>
												<div style={{ display: 'inline-block', width: '65%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
													{this.props.receiver.getString(point_type) + ' (' + this.props.receiver.getString(point_unit) + ')'}
												</div>

												<div style={{ marginLeft: 10, display: 'inline-block', width: '30%' }} ref={(divElement) => { this.divElement = divElement }}>
													{/*this.props.receiver.getString(yellow_label) + ": " + point_yellow*/}
													{yellow_label} {point_yellow}
												</div>
											</div>

											{/* <div style={{ width: '100%', display: 'block', paddingBottom: 10 }}>
												<div style={{ marginLeft: 10, display: 'inline-block', width: '23%' }}>
													{this.props.receiver.getString('threshold')}
												</div>
												
												<div style={{ display: 'inline-block', width: '17%' }}>
													{this.props.receiver.getString(yellow_label) + ": "}
												</div>
												
												<div style={{ display: 'inline-block', width: '19%' }}>
													{point_yellow}
												</div>
												
												<div style={{ display: 'inline-block', width: '16%' }}>
													{this.props.receiver.getString(red_label) + ": "}
												</div>
												
												<div style={{ marginRight: 10, display: 'inline-block', width: '18%' }}>
													{point_red}
												</div>
											</div> */}
										</div>
									)
								} else {
									return null;
								}
							})}
						</div>

						{/* <div id='add_iaq_command' onClick={this.handleAddIAQCommand} style={{ marginTop: 20, padding: 5, width: this.props.width - 80, marginLeft: 'auto', marginRight: 'auto', minWidth: 30, verticalAlign: 'top', textAlign: 'center' }}>
							<span> + </span>
						</div> */}
					</div>
				</div>
			</div>
		)
	}
}